import { CartDrawerToggleEvent, CartContentUpdateEvent, CartDrawerStateChangeEvent, CartDrawerCloseEvent } from "@gob/events";

const selectors = {
  closeButton: '[data-close-button]',
  content: '[data-cart-drawer-content]',
}

class ComponentCartDrawer extends HTMLElement {
  #state = 'closed';

  constructor() {
    super();

    this.handleCartContentUpdate = this.handleCartContentUpdate.bind(this);
    this.handleCartDrawerToggle = this.handleCartDrawerToggle.bind(this);
    this.openCartDrawer = this.openCartDrawer.bind(this);
    this.closeCartDrawer = this.closeCartDrawer.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }
  
  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.closeCartDrawer();
    }
  }

  handleOutsideClick(event) {
    if (this.#state === 'closed') return;
    if (!this.contains(event.target)) {
      this.closeCartDrawer();
    }
  }

  handleCartContentUpdate(event) {
    if (!this.content || !event.html) return;
    
    this.content.innerHTML = event.html;
    this.content.querySelectorAll('cart-line').forEach(line => {
      line.dataset.index = line.dataset.index;
    });

    this.openCartDrawer();
  }

  openCartDrawer() {
    this.#state = 'open';
    this.setAttribute('data-state', this.#state);
    this.removeAttribute('inert');

    requestAnimationFrame(() => {
      window.addEventListener('click', this.handleOutsideClick, { passive: true });
    });
  }

  closeCartDrawer() {
    this.#state = 'closed';
    this.setAttribute('data-state', this.#state);
    this.setAttribute('inert', '');
    window.removeEventListener('click', this.handleOutsideClick, { passive: true });
  }

  handleCartDrawerToggle(event) {
    this.#state = this.#state === 'open' ? 'closed' : 'open';
    this.#state === 'open' ? this.openCartDrawer() : this.closeCartDrawer();
    window.dispatchEvent(new CartDrawerStateChangeEvent(this.#state === 'open'));
  }

  connectedCallback() {
    this.closeButton = this.querySelector(selectors.closeButton);
    this.content = this.querySelector(selectors.content);
    this.interactiveElements = this.querySelectorAll('a')

    window.addEventListener(CartDrawerToggleEvent.eventName, this.handleCartDrawerToggle, { passive: true });
    window.addEventListener(CartContentUpdateEvent.eventName, this.handleCartContentUpdate, { passive: true });
    window.addEventListener(CartDrawerCloseEvent.eventName, this.closeCartDrawer, { passive: true });
    window.addEventListener('keydown', this.handleKeydown, { passive: true });
    this.interactiveElements?.forEach(el => {
      el?.addEventListener('click', this.closeCartDrawer, { passive: true });
    })
    this.closeButton?.addEventListener('click', this.closeCartDrawer, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener(CartDrawerToggleEvent.eventName, this.handleCartDrawerToggle, { passive: true });
    window.removeEventListener(CartContentUpdateEvent.eventName, this.handleCartContentUpdate, { passive: true });
    window.removeEventListener(CartDrawerCloseEvent.eventName, this.closeCartDrawer, { passive: true });
    window.removeEventListener('keydown', this.handleKeydown, { passive: true });
    this.interactiveElements?.forEach(el => {
      el?.removeEventListener('click', this.closeCartDrawer, { passive: true });
    })
    this.closeButton?.removeEventListener('click', this.closeCartDrawer, { passive: true });
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', ComponentCartDrawer);
}